import { ArrowRight, Check, Shield, TrendingUp } from "lucide-react";
import { Button } from "../ui/button";
import SectionLogo from "../SectionLogo";

const CHIRO_BENEFITS = [
  "Reduce inflammation before adjustments",
  "Enhance patient recovery between visits",
  "Offer a premium add-on service",
  "Support soft tissue healing",
  "Increase patient satisfaction and retention",
  "No equipment investment required",
];

const PT_BENEFITS = [
  "Accelerate post-therapy recovery",
  "Reduce pain and swelling for patients",
  "Complement rehab and exercise programs",
  "Support athletes returning from injury",
  "Mobile service comes to your clinic",
  "Flexible scheduling around patient needs",
];

export const ChiroPTSection = ({ scrollToSection }) => {
  return (
    <section id="chiro-pt" className="py-24 bg-[#0a0318] relative">
      <SectionLogo position="left" size="medium" opacity={0.05} />
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-green-500/10 border border-amber-500/30 rounded-full px-4 py-2 mb-4">
              <span className="text-sm text-amber-300 font-medium">Healthcare Partners</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Partner With Ice Man Cryo: <span className="text-amber-400">Chiropractors</span> &{" "}
              <span className="text-amber-400">Physical Therapists</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              Enhance your practice with targeted cryotherapy. Ice Man Cryo brings mobile recovery services that
              complement your treatment plans and support patient outcomes.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-600 to-amber-400 flex items-center justify-center">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-amber-400">For Chiropractors</h3>
              </div>
              <div className="space-y-4">
                {CHIRO_BENEFITS.map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-amber-400 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-300">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-600 to-amber-400 flex items-center justify-center">
                  <TrendingUp className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-amber-400">For Physical Therapists</h3>
              </div>
              <div className="space-y-4">
                {PT_BENEFITS.map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-amber-400 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-300">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-[#110422]/50 border border-amber-500/20 rounded-xl p-6 inline-block mb-6">
              <p className="text-amber-400 font-semibold text-sm">
                Monthly & multiple treatment packages available at 20% discount. Must be prepaid.
              </p>
            </div>
            <div className="block">
              <Button
                onClick={() => scrollToSection("booking")}
                className="bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white px-8 py-6 text-lg"
                data-testid="chiro-pt-book-btn"
              >
                Schedule a Partner Consultation <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
